module.exports = __webpack_public_path__ + "img/barcelo-room.79dafb72.jpg";